/* eslint-disable import/prefer-default-export,no-new,no-console,prefer-const,no-unused-vars */
import Cookies from '@/services/cookies'
import * as types from './mutation_types'
import queryParamsRules from '@/config/queryParamsRules.js'
import technicalCustomizations from '@/config/technicalCustomizations.js'
import { forEach, merge, reduce } from 'lodash'
import apiVCP from '@/api/vcp'

export default {
  processSpecificQueryParams: ({
    rootState,
    commit,
    rootGetters,
    getters,
    dispatch,
  }) =>
    new Promise(resolve => {
      let paramsObj = {}
      const urlSearchParams = new URLSearchParams(window.location.search)
      const params = Object.fromEntries(urlSearchParams.entries())
      let queryHasUtms = reduce(
        Object.keys(queryParamsRules.utms),
        (res, key) => {
          return res || params[key]
        },
        false,
      )
      if (queryHasUtms) {
        forEach(Object.keys(queryParamsRules.utms), key => {
          Cookies.remove(key)
        })
      }
      forEach(
        merge(queryParamsRules.other, queryParamsRules.utms),
        (param, key) => {
          if (Cookies.get(key)) {
            paramsObj[key] = Cookies.get(key)
          } else if (key === 'cmz' && getters.specificQueryParams.cmz) {
            paramsObj[key] = getters.specificQueryParams.cmz
          }
          if (params[key]) {
            // для айди кастомизации не ставим куку, чтобы поставить её потом, когда скачаем конфиг и узнаем, сколько она должна лежать
            if (key !== 'cmz') {
              Cookies.set(key, params[key], {
                expires: param.days,
              })
            }

            paramsObj[key] = params[key]
          }
        },
      )
      if (
        document.referrer &&
        !document.referrer.includes(window.location.hostname)
      ) {
        Cookies.set('document_referrer', document.referrer, {
          expires: 30,
        })
      }
      if (paramsObj.cmz) {
        delete paramsObj.invite
      }
      // если инфайтная ссылка, показать спец кастомник (технический лендос)
      if (paramsObj.invite) {
        paramsObj.cmz = (rootGetters['city/isRegion'] ? technicalCustomizations.inviterRegions : technicalCustomizations.inviterGf)
      }
      commit(types.SET_SPECIFIC_QUERY_PARAMS_FULLY, paramsObj)

      // dispatch(
      //   'analytics/trackVariable',
      //   {
      //     key: 'cmz',
      //     value: paramsObj.cmz,
      //   },
      //   { root: true },
      // )
      resolve()
    }),
  getFAQ: async ({ rootState, rootGetters }, category) => {
    const payload = {
      category,
      brandId_H: 'lY',
      cityId: rootGetters['city/getActive'].id,
    }
    try {
      let response = rootGetters['client/isLoggedIn']
        ? await apiVCP.getFAQ(payload)
        : await apiVCP.getFAQNoAuth(payload)
      return response.data
    } catch (error) {
      console.log(error)
      return error?.response?.data
    }
  },
  setExpressDeliveryState: ({ commit }, value) => {
    commit(types.SET_EXPRESS_DELIVERY_SELECTED_STATE, value)
  },
}
